/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconSwapVertical12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSwapVertical12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="m5.145 4.317.707-.707-2.354-2.355L1.145 3.61l.707.707L2.998 3.17v7.34h1V3.17l1.147 1.147ZM10.145 7.693l.707.707-2.354 2.355L6.145 8.4l.707-.707L7.998 8.84V1.5h1v7.34l1.147-1.147Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSwapVertical16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSwapVertical16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m6.86 5.756.943-.943-3.139-3.14-3.138 3.14.943.943 1.529-1.53v9.787H5.33V4.227l1.529 1.53ZM13.527 10.257l.943.943-3.138 3.14-3.138-3.14.942-.943 1.529 1.53V1.998h1.333v9.787l1.529-1.53Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSwapVertical20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSwapVertical20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="m8.574 7.195 1.178-1.179L5.83 2.092 1.907 6.016l1.179 1.18 1.91-1.912v12.233h1.667V5.284l1.91 1.911ZM16.908 12.821l1.178 1.18-3.922 3.924L10.24 14l1.179-1.179 1.91 1.912V2.499h1.667v12.234l1.91-1.912Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSwapVertical24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSwapVertical24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m10.29 8.634 1.413-1.415-4.707-4.71L2.29 7.22l1.414 1.415L5.996 6.34v14.68h2V6.34l2.293 2.294ZM20.29 15.385l1.414 1.415-4.707 4.71-4.707-4.71 1.414-1.415 2.293 2.294V3h2v14.68l2.293-2.294Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconSwapVertical = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSwapVertical(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconSwapVertical12 {...iconProps} />;
        case '16':
            return <IconSwapVertical16 {...iconProps} />;
        case '20':
            return <IconSwapVertical20 {...iconProps} />;
        case '24':
            return <IconSwapVertical24 {...iconProps} />;
        default:
            return <IconSwapVertical24 {...iconProps} />;
    }
});
